<ng-container
  *ngIf="
    { memberDetails: memberDetails$ | async, memberCard: memberCard$ | async, ecash: ecash$ | async } as memberInfo;
    else loadingRef
  "
>
  <div class="member-card text-white mb-3">
    <div class="member-card-title mb-3" [routerLink]="['/account']">
      <div class="name text-primary">
        <span>{{ 'member.card.hello' | translate }}, </span><span>{{ memberInfo.memberDetails.FirstName }}</span>
      </div>
      <div class="material-icons text-secondary cursor-pointer" *ngIf="!isAccountPage">arrow_outward</div>
    </div>
    <ng-container *ifScreenSize="screenType.Mobile">
      @if (wallet) {
        <div class="member-card-wallet card rounded border">
          <ng-container *ngIf="{ barcode: barcode$ | async } as member">
            <ng-container *ngIf="member.barcode.Barcode; else loadingRef">
              <div class="qrcode-wrapper mt-3">
                <qrcode
                  [qrdata]="member.barcode.Barcode"
                  [width]="131"
                  [errorCorrectionLevel]="'M'"
                  [elementType]="'svg'"
                  [margin]="0"
                ></qrcode>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *notInProductCode="productcode.SingleGameBuyer">
            <div class="scan-text text-center font-size-14 font-praktika-normal mt-3 mb-2">
              {{ 'barcode.description' | translate }}
            </div>
          </ng-container>

          <ng-container *inProductCode="productcode.SingleGameBuyer">
            <div class="scan-text text-center font-size-14 font-praktika-normal mt-3 mb-2">
              {{ 'barcode.description.sgb' | translate }}
            </div>
          </ng-container>
          <ng-container *notInProductCode="productcode.SingleGameBuyer">
            <div class="member-card-body w-100">
              <div class="values mt-lg-0 mt-3 w-100">
                <div class="w-100" [ngClass]="{ hidden: memberInfo.memberCard.DiscountLevel <= 0 }">
                  <div class="member-card-value cursor-pointer" (click)="openModal()">
                    <div class="value">{{ memberInfo.memberCard.DiscountLevel }}%</div>
                    <div class="title">
                      {{ 'member.card.discount.label' | translate }}
                    </div>
                  </div>
                </div>

                <div class="w-100">
                  <div class="member-card-value">
                    <div class="value">
                      {{ pointsBalance$ | async }}
                    </div>
                    <div class="title">{{ 'member.card.claws.label' | translate }}</div>
                  </div>
                </div>

                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.ecash'">
                  <div class="w-100">
                    <div class="member-card-value">
                      <div class="value">
                        {{ memberInfo.ecash | FortressCurrencyPipe: '$' }}
                      </div>
                      <div class="title">{{ 'member.card.grizzbucks.label' | translate }}</div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="cardBody; context: { $implicit: memberInfo }"></ng-container>
      }
    </ng-container>

    <ng-container *ifScreenSize="screenType.Desktop">
      <ng-container *ngTemplateOutlet="cardBody; context: { $implicit: memberInfo }"></ng-container>
    </ng-container>
  </div>
</ng-container>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>

<ng-template #cardBody let-memberInfo>
  <div class="member-card-body d-lg-flex bg-primary rounded border border-secondary">
    <ng-container *notInProductCode="productcode.SingleGameBuyer">
      <div class="img-holder pe-0">
        <img class="rounded" src="assets/images/member-card/{{ memberInfo.memberCard.ProductCode }}.png" draggable="false" />
      </div>

      <div class="member-card-values">
        <div class="values mt-lg-0 mt-3">
          <div class="widget-width" [ngClass]="{ hidden: memberInfo.memberCard.DiscountLevel <= 0 }">
            <div class="member-card-value cursor-pointer" (click)="openModal()">
              <div class="value">{{ memberInfo.memberCard.DiscountLevel }}%</div>
              <div class="title">
                {{ 'member.card.discount.label' | translate }}
              </div>
            </div>
          </div>

          <div class="widget-width">
            <div class="member-card-value">
              <div class="value">
                {{ pointsBalance$ | async | number: '1.0-0' }}
              </div>
              <div class="title">{{ 'member.card.claws.label' | translate }}</div>
            </div>
          </div>

          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.ecash'">
            <ng-container *ngIf="memberInfo.ecash > 0">
              <div class="widget-width">
                <div class="member-card-value">
                  <div class="value">
                    {{ memberInfo.ecash | FortressCurrencyPipe: '$' }}
                  </div>
                  <div class="title">{{ 'member.card.grizzbucks.label' | translate }}</div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <!--Direct Auth-->
        <ng-container *ifScreenSize="screenType.Desktop">
          <fgb-ecash-button></fgb-ecash-button>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *inProductCode="productcode.SingleGameBuyer">
      <div class="img-holder pe-0">
        <div class="bg-secondary sgb-image-container rounded">
          <img class="rounded sgb-image" src="assets/images/login-image.svg" draggable="false" />
        </div>
      </div>
    </ng-container>

    <div class="px-0 mt-3 mb-2 d-lg-none mx-0" *ngIf="!isMobileMenu">
      <a class="show-card-button font-praktika-bold border border-secondary" [routerLink]="'/rewards/wallet'">
        <span class="material-icons icon"> qr_code </span>
        {{ 'show.card.button' | translate }}
      </a>
    </div>
  </div>

  <!--Direct Auth-->
  <ng-container *ifScreenSize="screenType.Mobile">
    <fgb-ecash-button></fgb-ecash-button>
  </ng-container>
</ng-template>
